// ─────────────────────────────────────────────────────────────────────────────
// Logo (MobiConnect WebAPI) modul yapilandirmasi.
//
// BU MODULU BASKA BIR PROJEYE KOPYALADIGINDA DEGISTIRMEN GEREKEN TEK DOSYA.
// Modulun geri kalani buradan okur; disaridan hicbir seye bagimli degildir.
// ─────────────────────────────────────────────────────────────────────────────

export interface LogoConfig {
  /** MobiConnect WebAPI taban adresi (Swagger'daki Server). Sonunda / olmadan. */
  baseUrl: string;
  /** Logo oturumu icin varsayilan kimlik bilgileri. */
  login: {
    username: string;
    password: string;
    firmaNo: number;
  };
  /**
   * Oturum cerez tabanli (ASP.NET Core / Kestrel). axios'un cerezleri tasimasi
   * icin true. Farkli origin'de CORS + credentials ayari gerekebilir.
   */
  withCredentials: boolean;
  /** Istek timeout (ms). */
  timeoutMs: number;
}

// Ortam degiskeniyle override edilebilir (CRA: REACT_APP_*). Yoksa asagidaki sabit.
const env = (typeof process !== 'undefined' ? process.env : {}) as Record<string, string | undefined>;

export const logoConfig: LogoConfig = {
  baseUrl: env.REACT_APP_LOGO_API_BASE ?? 'https://localhost:7240',
  login: {
    username: env.REACT_APP_LOGO_USER ?? 'logo',
    password: env.REACT_APP_LOGO_PASS ?? 'logo',
    firmaNo: Number(env.REACT_APP_LOGO_FIRMA ?? 1),
  },
  withCredentials: true,
  timeoutMs: 30000,
};

/** Calisma aninda config'i kismi olarak guncelle (orn. farkli firma/sunucu). */
export function configureLogo(patch: Partial<LogoConfig>): void {
  Object.assign(logoConfig, patch);
  if (patch.login) Object.assign(logoConfig.login, patch.login);
}
